gibe.product = {

	preInit: function() {
		// continue
		gibe.product.init();
	},

	init: function () {
		$('.m-product:not(.js-product-done)').each(function () {
			var wrapper = $(this);
			var currentProduct = null;
			var currentProductGuid = wrapper.find('#jsProductGuid').val();

			if (typeof currentProductGuid === 'undefined') return;

			var data = wrapper.find('script#jsProductData').html();
			try {
				data = $.parseJSON(data);
			}
			catch (e) {
				if (console !== 'undefined') {
					console.log('Error: Could not parseJSON for data: product.js');
				}
			}

			if (data.constructor === Array) {
				for (var i = 0; i < data.length; i++) {
					if (data[i].Guid === currentProductGuid) {
						currentProduct = data[i];
						break;
					}
				}
			}
			else {
				currentProduct = data;
			}

			// move
			gibe.product.moveItems();

			// gallery
			gibe.product.gallery(wrapper, currentProduct.ImageModels);

			// compatibility
			var compatibility = wrapper.find('script#jsProductCompatibility');
			if (compatibility.length == 1) {
				try {
					compatibility = $.parseJSON(compatibility.html());
				}
				catch (e) {
					if (console !== 'undefined') {
						console.log('Error: Could not parseJSON for compatibility: product.js');
					}
				}
				wrapper.find('a.js-popup-compatibility').off('click').on('click', function () {
					var link = $(this);
					popups.productCompatibility(compatibility[currentProduct.Name]);
					return false;
				});
			}

			// done
			wrapper.addClass('js-product-done');
		});
	},

	moveItems: function () {
		// some items need to move to a different part of the doc
		var html = $('#jsProductSpec').clone().addClass('duplicate');
		$('#jsProductAside').html(html);
		// trigger ajax
		site.doc.trigger('ajaxComplete');
	},

	gallery: function (p, data, video) {

		p.find('.m-product__gallery .m-product__gallery__inner:not(.js-gallery-done)').each(function () {
			var wrapper = $(this);
			var gallery = wrapper.find('.js-gallery');
			var pager = wrapper.find('.js-pager');
			var imageSlider, pagerSlider, i;

			// load additional images & pager
			if (data != null && data.length > 1) {
				var tmpImage = $('#productGalleryImageTemplate').html();
				tmpImage = Hogan.compile(tmpImage);

				var tmpPager = $('#productGalleryPagerTemplate').html();
				tmpPager = Hogan.compile(tmpPager);

				// clear existing items
				gallery.empty();
				pager.empty();

				// append new items
				for (i = 0; i < data.length; i++) {
					var item = data[i];
					if (i == (data.length - 1)) {
						item.VideoUrl = video;
					}
					gallery.append(tmpImage.render(item));
					pager.append(tmpPager.render(item));
				}

				// image slider functionality
				var slides = gallery.find('.js-slide');
				if (slides.length > 1) {
					imageSlider = gallery.bxSlider({
						mode: 'fade',
						pagerCustom: '#jsGalleryPager',
						speed: 500,
						infiniteLoop: false,
						hideControlOnEnd: true
					});
				}

				// pager slider functionality
				slides = pager.find('.js-item');
				if (slides.length > 1) {
					pagerSlider = pager.bxSlider({
						pager: false,
						speed: 500,
						minSlides: 4,
						maxSlides: 4,
						moveSlides: 1,
						slideWidth: 145,
						slideMargin: 1,
						infiniteLoop: false,
						hideControlOnEnd: true
					});
				}

				// trigger ajax
				site.doc.trigger('ajaxComplete');
			}

			// done
			wrapper.addClass('js-gallery-done');
		});
	}

};

$(function () {
	gibe.product.preInit();
	site.doc.ajaxComplete(function () {
		gibe.product.init();
	});
});